import {MDCToolbar} from '@material/toolbar/index';
import {MDCRipple} from '@material/ripple/index';
import MDCFoundation from '@material/ripple/foundation';

class AppBar {

    constructor(appBar) {
        this.appBar = appBar
        this.topAppBar = new MDCToolbar(appBar);

        this.searchInput = this.appBar.querySelector('.appbar-search-input');
        this.searchButton = this.appBar.querySelector('.appbar-action-button-search');
        this.closeButton = this.appBar.querySelector('.appbar-action-button-close');
        this.searchLabel = this.appBar.querySelector('.appbar-search-label');

        this.SEARCH_ACTIVE_CLASS = 'appbar-search-open';
        this.SEARCH_FILLED_CLASS = 'appbar-search-filled';

        this.setupCloseIconRipple();
        this.setupEventListeners();
    }

    openSearch() {
        document.body.classList.add(this.SEARCH_ACTIVE_CLASS);
        this.searchInput.focus();
    }

    closeSearch() {
        document.body.classList.remove(this.SEARCH_ACTIVE_CLASS);
        this.searchInput.value = '';
        this.toggleSearchLabel(true);
    }

    setupEventListeners() {
        this.searchButton.addEventListener('click', () => {
            this.openSearch();
        });

        this.closeButton.addEventListener('click', () => {
            this.closeSearch();
        });

        this.searchLabel.addEventListener('click', () => {
            this.searchInput.focus();
        });

        this.searchInput.addEventListener('input', ()=> {
            this.toggleSearchLabel(this.searchInput.value == "");
        });        
    }

    toggleSearchLabel(showLabel) {
        this.searchLabel.classList.toggle(this.SEARCH_FILLED_CLASS, !showLabel);
    }

    setupCloseIconRipple() {
        const closeIcon = this.appBar.querySelector('.appbar-icon-close');
        const foundation = new MDCFoundation({
            // ...
            computeBoundingRect: () => {
            const {left, top} = closeIcon.getBoundingClientRect();
            const dim = 24;
            return {
                left,
                top,
                width: dim,
                height: dim,
                right: left + dim,
                bottom: top + dim
            };
            }
        });
        const ripple = new MDCRipple(closeIcon, foundation);
        ripple.unbounded = true;
        ripple.activate();
    }
}

export {AppBar};